// @core/api/endpoints/bootstrap/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AcknowledgeVaultKeys } from './acknowledge_vault_keys';
import { Execute } from './execute';
import { GetExecutionProgress } from './get_execution_progress';
import { GetStatus } from './get_status';
import { GetSystemInfo } from './get_system_info';
import { GetWizardSteps } from './get_wizard_steps';
import { ProbeVaultStatus } from './probe_vault_status';
import { Reset } from './reset';
import { RetryExecution } from './retry_execution';
import { SaveAdminAccount } from './save_admin_account';
import { SavePlatformIdentity } from './save_platform_identity';
import { SavePlatformMode } from './save_platform_mode';
import { SaveProductSelection } from './save_product_selection';
import { SaveSecurityConfig } from './save_security_config';
import { SaveVaultConfig } from './save_vault_config';
import { TestAutoUnseal } from './test_auto_unseal';
import { TestLdapConnection } from './test_ldap_connection';
import { TestOidcProvider } from './test_oidc_provider';
import { ValidateSlug } from './validate_slug';
import { ValidateStep } from './validate_step';

// Re-export individual endpoints
export {
  AcknowledgeVaultKeys,
  Execute,
  GetExecutionProgress,
  GetStatus,
  GetSystemInfo,
  GetWizardSteps,
  ProbeVaultStatus,
  Reset,
  RetryExecution,
  SaveAdminAccount,
  SavePlatformIdentity,
  SavePlatformMode,
  SaveProductSelection,
  SaveSecurityConfig,
  SaveVaultConfig,
  TestAutoUnseal,
  TestLdapConnection,
  TestOidcProvider,
  ValidateSlug,
  ValidateStep,
};

// Namespace export for convenient usage
export const bootstrapApi = {
  AcknowledgeVaultKeys,
  Execute,
  GetExecutionProgress,
  GetStatus,
  GetSystemInfo,
  GetWizardSteps,
  ProbeVaultStatus,
  Reset,
  RetryExecution,
  SaveAdminAccount,
  SavePlatformIdentity,
  SavePlatformMode,
  SaveProductSelection,
  SaveSecurityConfig,
  SaveVaultConfig,
  TestAutoUnseal,
  TestLdapConnection,
  TestOidcProvider,
  ValidateSlug,
  ValidateStep,
};
